// extracted by mini-css-extract-plugin
export default {"cls1":"u8PW0TeQR689dky2hjhv","cls2":"bVzTD4F0LzGJdqTfmdnm u8PW0TeQR689dky2hjhv"};